
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"currentColor","stroke-width":"1.25","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M5.295 6.875V18.75a.62.62 0 00.614.625H14.5a.62.62 0 00.614-.625V6.875"}}),_c('path',{attrs:{"d":"M15.114 10.625h3.068a.62.62 0 00.613-.625V5.625c0-2.76-2.198-5-4.909-5H12.66c0 1.38-1.099 2.5-2.454 2.5-1.356 0-2.455-1.12-2.455-2.5H6.523c-2.71 0-4.91 2.24-4.91 5V10a.62.62 0 00.614.625h3.068m4.91-7.5v2.5m2.455 2.5h-1.228"}})])])
          )
        }
      }
    